import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["inputContainer", "input", "arrow", "form"];

  transformInput() {
    event.target.classList.add("d-none");
    this.inputContainerTarget.classList.remove("d-none");
  }

  increment() {
    console.log(this.inputTarget.value.match(/[-\s]/));
    if (this.inputTarget.value.match(/[-\d]/)) {
      this.inputTarget.value = Number.parseInt(this.inputTarget.value) + 1;
    } else {
      this.inputTarget.value = 1;
    }
  }

  decrement() {
    if (this.inputTarget.value > 0) {
      this.inputTarget.value--;
    }
  }

  showArrows() {
    this.arrowTargets.forEach((target) => target.classList.remove("hide"));
  }

  hideArrows() {
    setTimeout(() => {
      this.arrowTargets.forEach((target) => target.classList.add("hide"));
    }, 2000);
  }

  submitForm() {
    this.formTarget.submit();
  }
}
